<div class="modal-container">
  <motif-modal-title class="title-container">
    <div class="title-container_top">
      <span>
        <h3 class="title-container_item">{{ 'commonGrid.filter.title' | translate }}</h3>
        &nbsp;
        <motif-badge type="warning" [number]="chipsFilters().length" class="filters-count">{{
          chipsFilters().length
        }}</motif-badge>
      </span>

      <div class="title-container_top-buttons">
        <button
          (click)="onClearAll()"
          aria-label="Clear All"
          class="borderless-button clear-filters"
          color="link-alt"
          motifButton>
          {{ 'commonGrid.filter.clear' | translate }}
        </button>
      </div>
    </div>
    <div>
      <span class="motif-body2-default-light title-container_top-description">{{
        'commonGrid.filter.description' | translate
      }}</span>
    </div>
  </motif-modal-title>
  <motif-modal-content>
    @if (chipsFilters().length > 0) {
      <div class="chips-container">
        <app-filter-chips
          (removeChip)="onRemoveChip($event)"
          [filterCriteria]="this.filterModalData.filterCriteria"
          [filters]="chipsFilters()"
          [location]="'filter-modal'"></app-filter-chips>
      </div>
    }
    <form [formGroup]="form" class="search-form">
      @for (filterCriterion of filterModalData.filterCriteria; track filterCriterion) {
        @if (hasAccess(filterCriterion.key)) {
          <div class="form-field-padding">
            <motif-form-field class="motif-form-field-label-outside">
              <label motifLabel for="{{ filterCriterion.key }}" aria-disabled="false">{{
                filterCriterion.label
              }}</label>
              @switch (filterCriterion.type) {
                @case (FieldType.Text) {
                  <input
                    motifInput
                    motifSearch
                    id="{{ filterCriterion.key }}"
                    type="text"
                    labelPosition="outside"
                    formControlName="{{ filterCriterion.key }}"
                    [placeholder]="filterCriterion.placeholder"
                    [attr.maxlength]="filterCriterion.maxLength"
                    [attr.aria-label]="filterCriterion.key" />
                }
                @case (FieldType.Date) {
                  <input
                    #dateInput
                    id="{{ filterCriterion.key }}"
                    labelPosition="outside"
                    formControlName="{{ filterCriterion.key }}"
                    [motifDatePicker]="dateFilter"
                    (dateTimeInput)="dateTimeInput($event)"
                    [motifDatePickerTrigger]="dateFilter"
                    [min]="getMinDate(filterCriterion)"
                    [max]="getMaxDate(filterCriterion)"
                    [placeholder]="filterCriterion.placeholder" />
                  <motif-date-picker #dateFilter />
                }
                @case (FieldType.MultipleSelect) {
                  <motif-select
                    [multiple]="true"
                    id="{{ filterCriterion.key }}"
                    labelPosition="outside"
                    formControlName="{{ filterCriterion.key }}"
                    [sortComparator]="dropdownOptionsSelectComparator"
                    [placeholder]="filterCriterion.placeholder"
                    [attr.aria-label]="filterCriterion.key"
                    searchPlaceholder="{{ 'commonGrid.filter.search' | translate }}"
                    [filter]="filterCriterion.filter">
                    @for (option of filterCriterion.options; track option) {
                      <motif-option [value]="option.value">{{ option.displayName }}</motif-option>
                    }
                  </motif-select>
                }
                @case (FieldType.Select) {
                  <motif-select
                    id="{{ filterCriterion.key }}"
                    formControlName="{{ filterCriterion.key }}"
                    labelPosition="outside"
                    [sortComparator]="dropdownOptionsSelectComparator"
                    [filter]="true"
                    [placeholder]="filterCriterion.placeholder"
                    [attr.aria-label]="filterCriterion.key">
                    @for (option of filterCriterion.options; track option) {
                      <motif-option [value]="option.value">{{ option.displayName }}</motif-option>
                    }
                  </motif-select>
                }
              }
            </motif-form-field>
          </div>
        }
      }
    </form>
  </motif-modal-content>
  <motif-modal-actions class="filter-actions" id="filter-actions">
    <button (click)="onCancel()" aria-label="Close" color="link" motifButton>
      {{ 'commonGrid.filter.cancel' | translate }}
    </button>
    <button
      (click)="$event.stopPropagation(); onSubmit(form)"
      [disabled]="isFormUnchanged"
      aria-label="Submit"
      color="primary"
      motifButton
      type="button">
      {{ 'commonGrid.filter.submit' | translate }}
    </button>
  </motif-modal-actions>
</div>
